<template>
    <div><currency-selector></currency-selector></div>
</template>

<script>
import lang from '../../shared/mixins/lang';
import CurrencySelector from './CurrencySelector.vue';

export default {
    mixins: [lang],
    components: {
        CurrencySelector,
    },
};
</script>
